import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import { IconSizes } from "atoms/constants/icon-sizes";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import NotebookPageCreateModal from "organisms/modals/notebook-page-create-modal/notebook-page-create-modal";
import React from "react";
import useModalActions from "utilities/hooks/use-modal-actions";
import { t } from "utilities/localization-utils";
export interface SidebarAddPageButtonProps {
    notebookId: number;
}

const BASE_CLASS_NAME = "c-sidebar-add-page-button";

const SidebarAddPageButton: React.FC<SidebarAddPageButtonProps> = ({
    notebookId,
}) => {
    const { isOpen, handleClose, handleOpen } = useModalActions();

    return (
        <>
            <Button
                style={ButtonStyles.Tertiary}
                cssClassName={BASE_CLASS_NAME}
                onClick={handleOpen}
                dataTestId="notebook-page--sidebar--add-page-button">
                <Icon
                    cssClassName={`${BASE_CLASS_NAME}__icon`}
                    type={Icons.Plus}
                    size={IconSizes.Base}></Icon>
                <span className={`${BASE_CLASS_NAME}__buttonText`}>
                    {t("notebooks-create-new-page")}
                </span>
            </Button>
            <NotebookPageCreateModal
                isVisible={isOpen}
                closeDialog={handleClose}
                notebookId={Number(notebookId)}
            />
        </>
    );
};

export default SidebarAddPageButton;
